<template>
  <div>
    <div class="card-body print-form" id="receiptData">
      <b-row class="">
        <b-col cols="12">
          <table style="width: 400px; font-weight: bold; color: grey">
            <tr>
              <td class="description" style="color: black; text-align: left">
                <span>
                  <h6
                    class="mb-0 tx-rubik text-center text-uppercase shop-header"
                  >
                    {{ new Date() | formatDateTime }}
                  </h6>
                  <h6
                    class="mb-0 tx-rubik text-center text-uppercase shop-header"
                  >
                    {{ Ordernumber }}
                  </h6>
                </span>
              </td>
            </tr>
          </table>
          <table style="width: 400px; margin: 0px 5px">
            <tr>
              <td class="description" style="color: black; text-align: left">
                <span>
                  <h1
                    class="mb-0 tx-rubik text-center text-uppercase shop-header"
                  >
                    KOT BILL
                  </h1>
                </span>
              </td>
            </tr>
          </table>
        </b-col>
      </b-row>

      <b-row>
        <b-col class="font-weight-bold">
          <table>
            <div class="row">
              <tr>
                <td>
                  <div class="col-lg-4">
                    <div class="col-lg-4 textAllignments" v-if="Table">
                      <span
                        class="tx-rubik"
                        style="color: black; text-align: left"
                      >
                        OrderPlace
                      </span>
                    </div>
                    <div
                      class="col-lg-4 textAllignments"
                      v-if="OrderDetailsData.guest"
                    >
                      <span
                        class="tx-rubik"
                        style="color: black; text-align: left"
                      >
                        Customer
                      </span>
                    </div>

                    <div
                      class="col-lg-4 textAllignments"
                      v-if="OrderDetailsData.waiter"
                    >
                      <span
                        class="tx-rubik"
                        style="color: black; text-align: left"
                      >
                        Waiter
                      </span>
                    </div>

                    <div class="col-lg-4 textAllignments">
                      <span
                        class="tx-rubik"
                        style="color: black; text-align: left"
                      >
                        Order type
                      </span>
                    </div>
                  </div>
                </td>
                <td class="numformat1">
                  <div class="col-lg-4">
                    <div class="col-lg-12">
                      <span class="numformat" style="font-size: 45px">
                        <b>{{ TicketNumber }}</b></span
                      >
                    </div>
                  </div>
                </td>
                <td>
                  <div class="col-lg-4">
                    <div
                      class="col-lg-4 textAllignments"
                      v-if="Table.text != null"
                    >
                      <span
                        class="tx-rubik"
                        style="color: black; text-align: left"
                      >
                        <b> {{ Table.text == 'select' ? '-' : Table.text }}</b>
                      </span>
                    </div>
                    <div
                      class="col-lg-4 textAllignments"
                      v-if="OrderDetailsData.guest"
                    >
                      <span
                        class="tx-rubik"
                        style="color: black; text-align: left"
                      >
                        {{ OrderDetailsData.guest }}
                      </span>
                    </div>

                    <div
                      class="col-lg-4 textAllignments"
                      v-if="OrderDetailsData.waiter"
                    >
                      <span
                        class="tx-rubik"
                        style="color: black; text-align: left"
                      >
                        {{ OrderDetailsData.waiter }}
                      </span>
                    </div>

                    <div class="col-lg-4 textAllignments">
                      <span
                        class="tx-rubik"
                        style="color: black; text-align: left"
                      >
                        {{ Method.text }}
                      </span>
                    </div>
                  </div>
                </td>
              </tr>
            </div>
          </table>
        </b-col></b-row
      >

      <!-- <b-dd-divider></b-dd-divider> -->
      <b-row>
        <b-col>
          <table style="width: 400px; margin: 0px 5px">
            <thead>
              <tr style="border-bottom: solid 2px">
                <th
                  class="description"
                  style="color: black; text-align: left; width: 200px"
                >
                  Item
                </th>
                <th
                  class="description"
                  style="color: black; text-align: center; width: 100px"
                >
                  Unit
                </th>
                <th
                  class="quantity"
                  style="
                    color: black;
                    text-align: center;
                    padding: 0px 10px;
                    width: 100px;
                  "
                >
                  Qty
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(product, index) in Order"
                :key="index"
                style="border-top: dashed 1px"
              >
                <td
                  class="description"
                  style="
                    color: black;
                    padding-top: 5px;
                    padding-bottom: 5px;
                    width: 100px;
                  "
                  v-if="product.dishItem"
                >
                  <h6 class="text-left padding-top-0px">
                    {{ product.dishItem.name }}
                  </h6>
                  <table class="width-100perc">
                    <tbody>
                      <tr
                        v-for="(item, index) in product.ingredients"
                        :key="index"
                        class="secondry-color text-left"
                      >
                        <td width="20px" class="text-right">+</td>
                        <td>Add {{ item.ingredient.name }}</td>
                      </tr>
                    </tbody>
                  </table>
                </td>

                <td class="text-center padding-top-0px">
                  <div v-if="product.unit && product">
                    <span v-if="product.unit.name">
                      {{ product.unit.name }}
                    </span>
                    <span v-if="product.unit.unit">
                      {{ product.unit.unit.name }}
                    </span>
                  </div>
                  <div v-if="product.dishItem.units">
                    <span>{{ product.dishItem.units.name }}</span>
                  </div>
                </td>

                <td style="color: black; text-align: center">
                  <span
                    style="color: black; text-align: right"
                    class="tx-rubik"
                    v-if="product.unit && product.unit.is_adjust"
                  >
                    {{ product.unit.count }}g
                  </span>
                  <span
                    style="color: black; text-align: right"
                    class="tx-rubik"
                    v-else
                  >
                    {{ product.count }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>

          <table style="width: 400px; margin: 0px 5px">
            <tr>
              <td
                colspan="2"
                class="description"
                style="color: black; text-align: left"
              >
                <hr style="border-top: solid 1px; margin: 1px" />

                <span
                  class="tx-rubik"
                  style="color: black; text-align: left; font-weight: bold"
                >
                  No of items - {{ Order.length }}
                </span>
              </td>
            </tr>

            <tr style="margin-top: 30px">
              <td
                colspan="2"
                style="
                  font-size: 12px;
                  padding-top: 20px;
                  color: black;
                  text-align: center;
                "
              >
                Powered by SpeedCodeLabs (Pvt) Ltd | 0212 211 599
              </td>
            </tr>
          </table>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrintBill',
  data() {
    return {
      printing: false,
    };
  },
  props: {
    Ordernumber: {
      type: String,
      default: '',
    },
    Order: {
      type: Array,
      default: [],
    },
    paymentType: {
      type: String,
      default: '',
    },
    Method: {
      type: String,
      default: '',
    },
    Table: {
      type: String,
      default: null,
    },

    OrderDetailsData: {
      type: [Array, Object],
      default: () => ({}),
    },
    TicketNumber: {
      type: String,
      default: null,
    },
  },
  components: {},
  computed: {},
  methods: {
    print() {
      this.$htmlToPaper('receiptData');
    },
  },
};
</script>
<style>
.numformat {
  font-size: 115px;

  margin-left: 17px;
  top: -54px;
}
.textAllignments {
  text-align: start;
  width: 80px;
}
.description,
.description {
  width: 80px;
  word-break: break-all;
  /* padding: 0px 10px; */
}

.unit-price,
.unit-price {
  width: 90px;
  word-break: break-all;
  /* padding: 0px 10px; */
}

.unit-price-text {
  text-align: right;
}

.quantity,
.quantity {
  width: 40px;
  word-break: break-all;
  /* padding: 0px 10px; */
}

.discount,
.discount {
  width: 90px;
  word-break: break-all;
  padding: 0px 10px;
}

.amount,
.amount {
  width: 100px;
  word-break: break-all;
  /* padding: 0px 10px; */
}

.centered {
  text-align: center;
  align-content: center;
}

.ticket {
  width: 155px;
  max-width: 155px;
}

img {
  max-width: inherit;
  width: inherit;
}
#receiptData {
  width: 100%;
  background: white;
}
</style>
